import React, { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import ContactInlineEditor from '../../../../../person/ContactInlineEditor';
import { FormContext } from '../../../../../common/form/FormContext';
import { getContactNameFromObject } from '../../../../../common/utils/commonUtils';
import { QuickAddPersonOption } from '../../../../../person/helpers/QuickAddPerson';
import { NameInput } from 'sr-types/lib/search/v1/graphql';
import { useStepper } from '../../../../../common/components/StepperContext';
import { ContactInput } from 'sr-types/lib/order/v1/graphql';

export default ({
    contact,
    setContact,
    fieldNameKey
}: {
    contact: QuickAddPersonOption;
    setContact: Dispatch<SetStateAction<QuickAddPersonOption>>;
    fieldNameKey: string;
}) => {
    const { setStepCompletion, activeStep } = useStepper();
    const { state, setState } = useContext(FormContext);
    const { id, ref } = contact;

    const currentContacts = state[fieldNameKey];
    const editedContactIndex = state[fieldNameKey].findIndex((c) => c.id === id || c.id === ref.id);

    const onSaveCompleted = (contactState: QuickAddPersonOption) => {
        const { contactInfo, name } = contactState;
        const newState = currentContacts.map((c, index) =>
            index === editedContactIndex
                ? {
                      ...contact,
                      contactInfo,
                      name: getContactNameFromObject(name as NameInput)
                  }
                : c
        );

        updateStates(newState);
    };

    const onCancel = () => {
        const newState = currentContacts.filter((c) => c.contactInfo?.email?.address);
        updateStates(newState);
    };

    const updateStates = (newContacts: ContactInput[]) => {
        setState((prev) => ({
            ...prev,
            [fieldNameKey]: newContacts
        }));
        setContact(null);
        setStepCompletion(activeStep, true);
    };

    return <ContactInlineEditor contact={contact} onSaveCompleted={onSaveCompleted} onCancel={onCancel} />;
};
